import { apiV2 } from 'shared';
import { normalizeData } from 'shared/hooks/useSupportedChains/utils';

import { IApiPackage } from './types';

export const fetchPackages = async () => {
  const { data } = await apiV2<IApiPackage[]>({
    headers: {
      'Content-Type': 'application/json',
    },
    url: '/networks/packages/',
    method: 'GET',
  });

  return normalizeData(data, 'contractId');
};
